import React, {Component} from "react"
import { Entity } from "aframe-react"

import frameButton from "../components-aframe/frameButton"

import controlBox from "../components-aframe/controlBox"

// const SmallResult = 

class ImageGrid extends Component {

    constructor(props) {
        super(props)

        this.const = {
            distance: -6,

            upDur: "350",
            downDur: "200",

            minOpacity: "0.7",
            maxOpacity: "1.0",

            maxScale: "1.5 1.5 1.5",
            midScale: "1.2 1.2 1.2",
            minScale: "1 1 1",
            
            smallWidth: 0.96,
            smallHeight: 0.6,

            largeWidth: 2.4,
            largeHeight: 1.5,
        }

        this.material = {
            shader: "flat",
            transparent: true,
            opacity: 0.7 
        }

        this.geometry = {
            primitive: "plane",

            width: this.const.smallWidth,
            height: this.const.smallHeight,
        }

        this.largeGeometry = {
            ...this.geometry,

            width: this.const.largeWidth,
            height: this.const.largeHeight,
        }

        this.largeMaterial = {
            ...this.material,
            opacity: 1.0,
        }
    }
    
    animationBase(attr, min, max, reverse=false) {
        return (
            <a-animation 
                attribute={attr}
                
                begin={(!reverse) ? "mouseenter" : "mouseleave"}
                end={(!reverse) ? "mouseleave" : "mouseenter"}
                
                dur={ (!reverse) ? this.const.upDur : this.const.downDur } 

                from={ (!reverse) ? min : max }
                to={ (!reverse) ? max : min}
            />
        )
    }

    opacityAnimation(reverse=false) {
        return this.animationBase(
            "material.opacity", 
            this.const.minOpacity, this.const.maxOpacity,
            reverse
        )
    }

    scaleAnimation(reverse=false) {
        return this.animationBase(
            "scale",
            this.const.minScale, this.const.maxScale,
            reverse
        )
    }

    bigScaleAnimation(reverse=false) {
        return this.animationBase(
            "scale",
            this.const.minScale, this.const.midScale,
            reverse
        )
    }

    smallImage(pos, item, geometry=this.geometry, material=this.material) {
        return (
            <Entity
                geometry={geometry}

                material={{
                    ...this.material,
                    src: item.src
                }}

                position={pos}

                events={{
                    clickUp: () => this.props.click(item) 
                }}

                frame-button={{ button: true }}
            >
                {this.opacityAnimation()}
                {this.opacityAnimation(true)}

                {this.scaleAnimation()}
                {this.scaleAnimation(true)}
            </Entity>
        )
    }

    bigImage(item) {
        return (
            <Entity
                geometry={this.largeGeometry}

                material={{
                    ...this.largeMaterial,
                    src: item.src
                }}

                position={{x: 0, y:0, z:0}}

                events={{
                    clickUp: () => this.props.click(item) 
                }}

                frame-button={{ button: true, }}
            >
                {this.bigScaleAnimation()}
                {this.bigScaleAnimation(true)}
            </Entity>
        )
    }

    render() {
        return (
            <Entity position={{x: 0, y: 0, z: 0}} control-box={{ enableX: false, offsetY: 30, offset: 20, doubleX: false, }}>
                <Entity position={{x: 0, y: 0, z: this.const.distance}}>
                    {this.bigImage(this.props.items[0])}

                    {this.props.items.slice(1,4).map( (item, index) =>
                        this.smallImage({x: -2.16, y:(index - 1)*0.9 + 0.45, z: 0}, item)
                    )}

                    {this.props.items.slice(4,7).map( (item, index) =>
                        this.smallImage({x: -2.16 + (index + 1)*1.44, y:1.35, z: 0}, item)
                    )}

                    {this.props.items.slice(7,9).map( (item, index) =>
                        this.smallImage({x: 2.16, y:(index - 1)*0.9 + 0.45, z: 0}, item)
                    )}
                </Entity>
            </Entity>
        )
    }

}

ImageGrid.defaultProps = {

    items: [],
    rotation: {x: 0, y: 0, z: 0},

}

export default ImageGrid


// WEBPACK FOOTER //
// ./src/components/ImageGrid.js